<template>

    <div>
        <h3 v-if="!institute.Logo" style="width: 100%; text-align: center">Loading...</h3>
        <table v-else>
            <thead> 
                <tr>
                    <td style="width: 12%">
                        <img :src="institute.Logo" style="height: 80px" />
                    </td>
                    <th style="width: 76%; background-color:white; vertical-align: middle;">
                        <button v-if="copyElement" v-on:click="copytable(copyElement)" style=" margin-top: -5px">Copy Data</button>
                        <button v-if="exportToExcel" v-on:click="exportTable(exportToExcel)" style=" margin-top: -5px">Export to Excel</button>
                        <h3 style="margin-bottom: -1px !important">{{institute.Name}}</h3>
                        <label>{{institute.Address}} {{institute.Contact}} </label>
                        <h4 class="p-t-b">{{h1}}</h4>
                        <h5 class="p-t-b">{{h2}}</h5>
                        <h5 class="p-t-b">{{h3}}</h5>
                        <h5 class="p-t-b">{{h4}}</h5>
                        <h6 class="p-t-b">{{h5}}</h6>
                    </th>
                    <td style="width: 12%; vertical-align: bottom; text-align: right"> 
                        <small>by: {{report.By}}</small>
                        <br />
                        <small>on: {{report.On}}</small>
                    </td>
                </tr>
                <tr>
                    <td colspan="3"> 
                        <hr />
                    </td>
                </tr>
            </thead>
        </table>
    </div>
</template>

<script>

    const axios = require('axios').default;
    var XLSX = require("xlsx");

    export default {
        props: {
            h1: String,
            h2: String,
            h3: String,
            h4: String,
            h5: String,
            copyElement: String,
            exportToExcel: Object,
        },
        data() {
            return {
                institute: {
                    Name: '',
                    Logo: '',
                    Address: '',
                    Contact: ''
                },

                report: {
                    By: '',
                    On: ''
                }
            }
        },

        created: function () {
            var vm = this;
            axios.post('/api/PortalApi/loadHeader')
                .then(function (res) {
                    vm.institute = res.data.institute;
                    vm.report = res.data.report;
                });
        },

        methods: {
            copytable(el) {
                var urlField = document.getElementById(el) 
                var range = document.createRange()
                range.selectNode(urlField)
                window.getSelection().addRange(range)
                document.execCommand('copy')
            },

            exportTable(excelObject) {
                const new_workbook = XLSX.utils.book_new();
                excelObject.tables.forEach(function (item) {
                    var table = XLSX.utils.table_to_sheet(document.getElementById(item.tbl));
                    XLSX.utils.book_append_sheet(new_workbook, table, item.name);
                });

                XLSX.writeFile(new_workbook, excelObject.sheetName + '.xls')
            }
        }
    }</script>

<style scoped>

    @media print {
        button {
            display: none;
        }
    }

    .p-t-b {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    small {
        font-size: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/school/core/header.vue